
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type, option_type, record_type, bool_type, string_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { TelematicsConnectionDeletedDto_$reflection, TelematicsConnectionDto_$reflection, TelematicsConnectionOverviewDto_$reflection, TelematicsVerificationDto_$reflection } from "../../../Shared/Telematics.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";
import { tryFindIndex, tryItem, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { bind } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export class WizardMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Setup", "ChangeKey"];
    }
}

export function WizardMode_$reflection() {
    return union_type("Settings.Telematics.Types.WizardMode", [], WizardMode, () => [[], []]);
}

export class WizardStep extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Provider", "Credentials", "Verify", "Summary"];
    }
}

export function WizardStep_$reflection() {
    return union_type("Settings.Telematics.Types.WizardStep", [], WizardStep, () => [[], [], [], []]);
}

export class Verification extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotVerified", "Verifying", "Verified", "Failed"];
    }
}

export function Verification_$reflection() {
    return union_type("Settings.Telematics.Types.Verification", [], Verification, () => [[], [], [["Item", TelematicsVerificationDto_$reflection()]], [["Item", string_type]]]);
}

export class Wizard extends Record {
    constructor(Mode, Step, ApiKey, ApiKeyVisible, Verification) {
        super();
        this.Mode = Mode;
        this.Step = Step;
        this.ApiKey = ApiKey;
        this.ApiKeyVisible = ApiKeyVisible;
        this.Verification = Verification;
    }
}

export function Wizard_$reflection() {
    return record_type("Settings.Telematics.Types.Wizard", [], Wizard, () => [["Mode", WizardMode_$reflection()], ["Step", WizardStep_$reflection()], ["ApiKey", string_type], ["ApiKeyVisible", bool_type], ["Verification", Verification_$reflection()]]);
}

export class State extends Record {
    constructor(Overview, LoadFailed, Wizard, StoredKeyTest, IsDisconnectDialogOpen, FormState) {
        super();
        this.Overview = Overview;
        this.LoadFailed = LoadFailed;
        this.Wizard = Wizard;
        this.StoredKeyTest = StoredKeyTest;
        this.IsDisconnectDialogOpen = IsDisconnectDialogOpen;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Telematics.Types.State", [], State, () => [["Overview", RequestedValue$1_$reflection(TelematicsConnectionOverviewDto_$reflection())], ["LoadFailed", bool_type], ["Wizard", option_type(Wizard_$reflection())], ["StoredKeyTest", Verification_$reflection()], ["IsDisconnectDialogOpen", bool_type], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConnectionFetched", "Reload", "OpenWizard", "CloseWizard", "NextStep", "BackStep", "SetApiKey", "ToggleApiKeyVisible", "VerifyWizard", "WizardVerified", "SaveWizard", "ConnectionSaved", "TestStoredKey", "StoredKeyTested", "OpenDisconnectDialog", "CloseDisconnectDialog", "Disconnect", "Disconnected", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Telematics.Types.Msg", [], Msg, () => [[["Item", TelematicsConnectionOverviewDto_$reflection()]], [], [["Item", WizardMode_$reflection()]], [], [], [], [["Item", string_type]], [], [], [["Item", ClientApiResponse$1_$reflection(TelematicsVerificationDto_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(TelematicsConnectionDto_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(TelematicsVerificationDto_$reflection())]], [], [], [], [["Item", ClientApiResponse$1_$reflection(TelematicsConnectionDeletedDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

export function WizardStepModule_forMode(mode) {
    if (mode.tag === 1) {
        return ofArray([new WizardStep(1, []), new WizardStep(2, []), new WizardStep(3, [])]);
    }
    else {
        return ofArray([new WizardStep(0, []), new WizardStep(1, []), new WizardStep(2, []), new WizardStep(3, [])]);
    }
}

export function WizardStepModule_next(mode, step) {
    const steps = WizardStepModule_forMode(mode);
    return bind((index) => tryItem(index + 1, steps), tryFindIndex((y) => equals(step, y), steps));
}

export function WizardStepModule_back(mode, step) {
    const steps = WizardStepModule_forMode(mode);
    return bind((index) => tryItem(index - 1, steps), tryFindIndex((y) => equals(step, y), steps));
}

export function WizardStepModule_key(step) {
    switch (step.tag) {
        case 1:
            return "credentials";
        case 2:
            return "verify";
        case 3:
            return "summary";
        default:
            return "provider";
    }
}

export function VerificationModule_isVerified(verification) {
    switch (verification.tag) {
        case 0:
        case 1:
        case 3:
            return false;
        default:
            return true;
    }
}

